import { render, staticRenderFns } from "./dg-alert-box.vue?vue&type=template&id=7263b08a"
import script from "./dg-alert-box.vue?vue&type=script&lang=js"
export * from "./dg-alert-box.vue?vue&type=script&lang=js"
import style0 from "./dg-alert-box.vue?vue&type=style&index=0&id=7263b08a&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports